import React from 'react';
import useRouter from './use-router';
import NotificationContext from '../contexts/notification-context';

function getErrorMessage(apiException) {
  return (
    apiException?.response?.data?.error ||
    apiException?.response?.data?.errorMessage ||
    apiException?.response?.data?.message
  );
}

function flattenErrorArrays(errorObject) {
  const flattenedErrors = {};

  Object.keys(errorObject).forEach(key => {
    const value = errorObject[key];
    if (value instanceof Array) {
      flattenedErrors[key] = value.join('. ');
    } else {
      flattenedErrors[key] = value;
    }
  });

  return flattenedErrors;
}

function handleHttpStatus(router, status) {
  if (status === 401) {
    router.history.push('/sign-in');
  } else {
    return false;
  }

  return true;
}

function handleErrorMessage(errorMessage, defaultMessage, notificationContext, formRef) {
  if (typeof errorMessage === 'object' && formRef?.current) {
    const flattenedErrors = flattenErrorArrays(errorMessage);
    formRef.current.setErrors(flattenedErrors);
  } else if (typeof errorMessage === 'string') {
    notificationContext.showDangerNotification(errorMessage);
  } else {
    notificationContext.showDangerNotification(defaultMessage);
  }
}

export default function useApiError(formRef) {
  const notificationContext = React.useContext(NotificationContext);
  const router = useRouter();

  return (apiException, defaultMessage) => {
    const errorMessage = getErrorMessage(apiException);

    if (!handleHttpStatus(router, apiException?.response?.status, errorMessage)) {
      handleErrorMessage(errorMessage, defaultMessage, notificationContext, formRef);
    }

    return errorMessage;
  };
}
